import { render, staticRenderFns } from "./PresupuestosConsolidadosLayout.vue?vue&type=template&id=49a8fb38&scoped=true"
import script from "./PresupuestosConsolidadosLayout.vue?vue&type=script&lang=js"
export * from "./PresupuestosConsolidadosLayout.vue?vue&type=script&lang=js"
import style0 from "./PresupuestosConsolidadosLayout.vue?vue&type=style&index=0&id=49a8fb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a8fb38",
  null
  
)

export default component.exports